export default __webpack_public_path__ + "static/media/pixelartgenerator.c61c0688.mp4";